import Modal from '../common/Modal';

interface DeleteContactModalProps {
  isOpen: boolean;
  title?: string;
  itemName?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteContactModal = ({
  isOpen,
  title = 'DELETE CONTACT',
  itemName = 'contact',
  onCancel,
  onConfirm
}: DeleteContactModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal onOverlayClicked={onCancel}>
      <div className="modal-header">
        <h1 className="modal-title">{title}</h1>
      </div>
      <div className="modal-body">
        <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.875rem' }}>
          Please confirm that you would like to delete this {itemName}.
        </p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px 20px' }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            width: '140px',
            height: '40px',
            backgroundColor: 'var(--color-danger)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          CANCEL
        </button>
        <button
          type="button"
          onClick={onConfirm}
          style={{
            width: '140px',
            height: '40px',
            backgroundColor: 'var(--color-accent)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          CONFIRM
        </button>
      </div>
    </Modal>
  );
};

export default DeleteContactModal;
